import React, { useContext } from 'react';
import { FC, ReactNode } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

import { AuthContext, AuthStatus } from 'src/contexts/authContext';

interface GuestGuardProps {
  children?: ReactNode;
}

const GuestGuard: FC<GuestGuardProps> = ({ children }) => {
  const { authStatus } = useContext(AuthContext);

  if (authStatus === AuthStatus.SignedIn) {
    return <Redirect to="/workspace/draft" />;
  }

  return <>{children}</>;
};

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default GuestGuard;
